var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.57143H12V3.04762H1.5V4.57143ZM1.5 15.2381C1.0875 15.2381 0.7345 15.089 0.441 14.7909C0.1475 14.4927 0.0005 14.1338 0 13.7143V3.04762C0 2.62857 0.147 2.26997 0.441 1.97181C0.735 1.67365 1.088 1.52432 1.5 1.52381H2.25V0H3.75V1.52381H9.75V0H11.25V1.52381H12C12.4125 1.52381 12.7657 1.67314 13.0597 1.97181C13.3537 2.27048 13.5005 2.62908 13.5 3.04762V7.37143C13.2625 7.25714 13.0187 7.1619 12.7687 7.08571C12.5187 7.00952 12.2625 6.95238 12 6.91429V6.09524H1.5V13.7143H6.225C6.3125 13.9937 6.41575 14.2603 6.53475 14.5143C6.65375 14.7683 6.79425 15.0095 6.95625 15.2381H1.5ZM11.25 16C10.2125 16 9.32825 15.6284 8.59725 14.8853C7.86625 14.1422 7.5005 13.2439 7.5 12.1905C7.4995 11.137 7.86525 10.2387 8.59725 9.49562C9.32925 8.75251 10.2135 8.38095 11.25 8.38095C12.2865 8.38095 13.171 8.75251 13.9035 9.49562C14.636 10.2387 15.0015 11.137 15 12.1905C14.9985 13.2439 14.6327 14.1425 13.9027 14.8861C13.1727 15.6297 12.2885 16.001 11.25 16ZM12.5062 14L13.0312 13.4667L11.625 12.0381V9.90476H10.875V12.3429L12.5062 14Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.214b4bbb46da804f78554f86a5899bf0.svg";
export { ForwardRef as ReactComponent };